import { useParams } from 'react-router-dom'
import useLoadSurvey from '../../../hooks/useLoadSurvey'
import AddElement from './AddElement/AddElement'
import ElementList from './ElementList/ElementList'
import Save from './Save/Save'
import styled from 'styled-components'
import OpenPreview from './OpenPreview/OpenPreview'
import { useSelector } from 'react-redux'
import props from '../../../../redux/props'
import CopyPublicLink from './CopyPublicLink/CopyPublicLink'

const ControlWrapper = styled.div`
  position: absolute;
  bottom: 16px;
  width: calc(100% - 32px);
  margin: 0 16px;
  display: flex;
  flex-direction: column;
  gap: 5px;
`

const Configuration = () => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const { surveyUUID } = useParams()
  const [survey, update, save, hasUnsavedChanges] = useLoadSurvey(surveyUUID)

  if (!survey) return <></>
  return (
    <div className="flex flex-row absolute top-0 h-screen w-full pt-16 overflow-hidden">
      <div className="w-3/12 h-full bg-blue relative">
        <div className="text-white text-xl px-5 pt-10 font-bold">{t.survey.type[survey.surveyType]}</div>
        <div className="font-italic text-white text-lg px-5 pb-10">{survey.context.departmentName}</div>
        <AddElement survey={survey} update={update} />
        <ControlWrapper>
          <Save save={save} hasUnsavedChanges={hasUnsavedChanges} />
          <OpenPreview uuid={surveyUUID} />
          <CopyPublicLink uuid={surveyUUID} />
        </ControlWrapper>
      </div>
      <div className="w-9/12 overflow-y-auto">
        <ElementList survey={survey} update={update} />
      </div>
    </div>
  )
}

export default Configuration
